module.exports = __webpack_public_path__ + "img/gzhQRcode.c41a529d.png";